import { Box, Button, Card, IconButton, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import api from '../../../service/api'
import TableHeader from '../../common/TableHeader'
import { formatDate } from '../../../utils/utilities'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import { OpenInNew } from '@mui/icons-material'
import noAssignmentImg from '../../../assets/noassignment.svg'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import AuditQuizViewer from './AuditQuizViewer'
import { useUserStore } from '../../../store/user.store'
import CustomTable from '../../common/custom-table/CustomTable'

const columns = [
    { id: 2, name: "Quiz name", field: "title", width: "120px", padding: "10px 20px" },
    { id: 3, name: 'Faculty name', sortable: true, filterable: true, field: "faculty_name", renderCell: row => row.faculty_name?.toLowerCase(), linkGetter: row => `/${window.location.pathname?.includes( 'admin' ) ? "admin" : "audit"}/faculty/${row.created_by}?legacy=${row.legacy_system_data}`, cellStyles: { textTransform: "capitalize" }, width: "180px", align: "left", padding: "10px 20px" },
    { id: 6, name: 'Institute', filterable: true, field: "institute", renderCell: row => row?.creator_data?.institute, padding: "10px 20px" },
    { id: 6, name: 'Department', filterable: true, field: "department", renderCell: row => row?.creator_data?.department?.toLowerCase(), cellStyles: { textTransform: "capitalize" }, padding: "10px 20px" },
    { id: 4, name: "Subject", field: "subject", renderCell: row => row.subject?.subject_name || "Not available", padding: "10px 20px" },
    { id: 5, field: "created_at", renderCell: row => formatDate( row.created_at ), name: "Created on", width: "150px", padding: "10px 20px" },
    { id: 7, align: "center", sortable: true, filterable: true, field: "instances", name: "instances", padding: "10px 20px" },
]


const FacultyAuditQuizzesList = () => {


    const [searchParams, setSearchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const searchText = searchParams.get( 'searchText' ) || ""
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const [error, setError] = useState( null )
    const [quizzes, setQuizzes] = useState( [] )
    const [loading, setLoading] = useState( true )
    const [selectedQuiz, setSelectedQuiz] = useState( null )

    const { layout } = useTheme()

    const navigate = useNavigate()

    const UserStore = useUserStore()

    const filterFunction = item => {
        if ( selectedDepartment !== "all" ) {
            const [department_id, legacy_department_id] = selectedDepartment?.split( "-" )
            return ( item.legacy_system_data && +legacy_department_id === +item?.creator_data?.department_id ) || ( !item.legacy_system_data && +department_id === +item?.creator_data?.department_id )
        }
        return true
    }

    const removeAppliedFilters = () => {
        setSearchParams( prev => {
            prev.set( 'searchText', '' )
            prev.set( 'selectedInstitute', "all" )
            prev.set( 'selectedDepartment', "all" )
            return prev
        } )
    }

    const handleDialogClose = ( refresh = false ) => {
        setSelectedQuiz( null )
        if ( refresh )
            getData()
    }


    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { data: { data } } = await api.audit.getQuizzesForAuditing( { institute: selectedInstitute !== "all" ? selectedInstitute : "" } )
            setQuizzes( data )
        } catch ( err ) {
            console.log( err )
            setError( err?.message?.data?.message || "Something went wrong while fetching quizzes." )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute] )

    useEffect( () => {
        getData()
    }, [getData] )


    return (
        <Box sx={{ flexShrink: 0, display: "flex", flexDirection: "column", gap: layout.cardsGap }}>

            {selectedQuiz && <AuditQuizViewer quiz={selectedQuiz} handleClose={handleDialogClose} openState={Boolean( selectedQuiz )} />}

            <Box display="flex" gap={layout.cardsGap} alignItems="flex-end" justifyContent="space-between">
                <Typography variant="h1" fontWeight="600" component="h2" fontSize="14px">Quizzes</Typography>
                <Button size="small" onClick={() => navigate( `/${["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) ? "admin" : "audit"}/quizzes` )} variant="contained" color='secondary' disableElevation sx={{ height: "33.5px", textTransform: "capitalize", }} >View Stats</Button>
            </Box >

            {!loading && quizzes.filter( filterFunction ).length > 0 && <CustomTable globalSearch tableKey="quizlist" containerStyles={{ maxHeight: "450px" }} onRowClick={row => setSelectedQuiz( row )} data={quizzes.filter( filterFunction )} pageSize={50} columns={columns} datIdKey="id" />}

            {!loading && quizzes.filter( filterFunction ).length === 0 && <Box flexDirection="column" padding="20px" display="flex" alignItems="center" justifyContent="center" gap="20px">
                <img src={noAssignmentImg} height="120px" alt="No assignmets to show" />
                <Typography textAlign="center" variant='subtitle2'>No quizzes were found for applied filters!</Typography>
                <Button onClick={removeAppliedFilters} sx={{ textTransform: "capitalize" }} color="secondary" variant="contained" disableElevation>Remove filters</Button>
            </Box>}

            {error && <TryAgainMessageBlock getData={getData} err={error} loading={loading} />}

            {loading && <DataLoadingSpinner padding="0" waitingMessage="Loading quizzes please wait...." />}
        </Box>
    )
}

export default FacultyAuditQuizzesList
